import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { useLocalization } from '@contexts/LocalizationContext'
import { Button, DatePicker, Form, Input, InputNumber, Row, Col } from 'antd'
// import dayjs from 'dayjs'

const FormComponent = ({
  handleSubmit,
  defaultValues = { posterImages: [] },
  isEdit = false,
}) => {
  const [form] = Form.useForm()

  const { t } = useLocalization()

  const tailLayout = {
    wrapperCol: {
      span: 20,
      offset: 2,
    },
  }

  const style = {
    inputShop: { width: '100%', height: '40px' },
    inputDateForm: { width: '100%', height: '40px' },

    btnStyleSummit: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },

    btnStyleSummitAdd: {
      // height: '37px',
      width: '232px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },
  }

  useEffect(() => {
    form.resetFields()
  }, [defaultValues])

  const { RangePicker } = DatePicker
  // const disabledDate = (current) => {
  //   return current && current < dayjs().endOf('day').add(-1, 'day')
  // }

  return (
    <Form
      layout="vertical"
      form={form}
      name="control-hooks"
      onFinish={handleSubmit}
      initialValues={defaultValues}
      requiredMark={false}
    >
      <div hidden>
        <Form.Item name="id">
          <Input />
        </Form.Item>
      </div>

      <Form.Item
        name="campaignId"
        label={t('campaign.form.label.campaignId')}
        defaultValue={defaultValues.campaignId || ''}
        rules={[
          {
            required: true,
            message: t('campaign.form.error.campaignId'),
          },
        ]}
      >
        <Input style={style.inputShop} />
      </Form.Item>

      <Form.Item
        name="title"
        label={t('campaign.form.label.title')}
        defaultValue={defaultValues.title || ''}
        rules={[
          {
            required: true,
            message: t('campaign.form.error.title'),
          },
        ]}
      >
        <Input style={style.inputShop} />
      </Form.Item>

      <Form.Item
        name="discount"
        defaultValue={defaultValues.discount || ''}
        label={t('campaign.form.label.discount')}
        rules={[
          {
            required: true,
            message: t('campaign.form.error.discount'),
          },
        ]}
      >
        <InputNumber style={style.inputShop} />
      </Form.Item>

      <Form.Item
        name="net"
        defaultValue={defaultValues.net || ''}
        label={t('campaign.form.label.net')}
        rules={[
          {
            required: true,
            message: t('campaign.form.error.net'),
          },
        ]}
      >
        <InputNumber style={style.inputShop} />
      </Form.Item>

      <Row style={{ alignItems: 'center', width: '100%' }}>
        <Row style={{ width: '100%', padding: '0px 0px 8px' }}>
          <Col span={12}>ระยะเวลาเริ่มต้น</Col>
          <Col span={12}>ระยะเวลาสิ้นสุด</Col>
        </Row>
        <Form.Item
          style={{ width: '100%' }}
          name="usableSinceToUntil"
          rules={[
            {
              required: true,
              message: 'กรุณาเลือกระยะเวลา',
            },
          ]}
        >
          <RangePicker
            style={style.inputDateForm}
            // disabledDate={disabledDate}
            format="YYYY-MM-DD"
          />
        </Form.Item>
      </Row>

      <Form.Item
        name="description"
        defaultValue={defaultValues.description || ''}
        label={t('campaign.form.label.description')}
        rules={[
          {
            required: true,
            message: t('campaign.form.error.description'),
          },
        ]}
      >
        <Input.TextArea style={{ ...style.inputShop, minHeight: 100 }} />
      </Form.Item>

      {/* เเสดงปุ่ม */}
      <Form.Item {...tailLayout}>
        <div style={{ textAlign: 'center' }}>
          <Button
            type="primary"
            htmlType="submit"
            style={style.btnStyleSummitAdd}
          >
            {isEdit
              ? t('campaign.form.editButton')
              : t('campaign.form.addData')}
          </Button>
        </div>
      </Form.Item>
    </Form>
  )
}
FormComponent.propTypes = {
  doStatus: PropTypes.string,
  handleSubmit: PropTypes.func,
  defaultValues: PropTypes.object,
  isEdit: PropTypes.bool,
}

export default FormComponent
